export default "__VITE_ASSET__BGvRul2l__"